import { Alert, Button, Divider, Form, Input, Space, Typography } from 'antd'
import { useState } from 'react'
import i18n from '../../i18n/setupLocalization'
import { useAuth } from '../../contexts/Auth'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { emailRule, requiredRule } from '../../helpers/rules'
import { Link } from 'react-router-dom'

const { Title } = Typography

export function ForgotPassword() {
  const { forgotPassword } = useAuth()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [result, setResult] = useState<string | undefined>(undefined)

  const handleSubmit = (values: { email: string }) => {
    setIsLoading(true)
    setResult(undefined)
    forgotPassword(values.email).finally(() => {
      setResult(i18n.t(LocalizationKeys.Page.ForgotPassword.Processed))
      setIsLoading(false)
    })
  }

  return (
    <Space direction="vertical">
      {result && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Alert style={{ marginBottom: 25 }} message={result} type="success" />
        </div>
      )}
      <Title level={2} style={{ textAlign: 'center' }}>
        {i18n.t(LocalizationKeys.Page.ForgotPassword.Title)} 🤯
      </Title>
      <Form onFinish={handleSubmit}>
        <Form.Item name="email" rules={[requiredRule(), emailRule()]}>
          <Input
            size="large"
            className="authField"
            placeholder={i18n.t(LocalizationKeys.Misc.Form.Email)}
            autoComplete="email"
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 15 }}>
          <Button
            size="large"
            className="w-full"
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            {i18n.t(LocalizationKeys.Page.ForgotPassword.Submit)}
          </Button>
        </Form.Item>
      </Form>
      <Space
        style={{ alignItems: 'center', width: '100%' }}
        direction="vertical"
      >
        <Link to={'/auth/login'}>
          {i18n.t(LocalizationKeys.Page.ForgotPassword.AlreadyHaveAccount)}
        </Link>
      </Space>
    </Space>
  )
}
